import { React, useEffect, useState, useCallback, useMemo } from 'react';
import debounce from "lodash.debounce";
import { useTranslation } from "react-i18next";
import { motion } from 'framer-motion';
import "./index.scss";

import SideNav from "../../components/PostLogin/SideNav";
import CustomersTileView from '../../components/PostLogin/Cutomers/CustomersTileView';
import CutomersListView from "../../components/PostLogin/Cutomers/CustomersListView/index.js";
import SideModal from '../../components/ui/SideModal';
import AddCustomerModal from '../../components/PostLogin/Cutomers/AddCustomer';
import Pagination from '../../components/ui/Pagination';
import NoDataFound from "../../components/ui/NoDataFound";
import SkeletonLoader from "../../components/ui/SkeletonLoader/index.js";

import { tileViewIcon, listViewIcon, searchIcon } from "../../utils/icons.js";
import { formatNumber } from "../../utils/util.js";

import { useSelector, useDispatch } from 'react-redux';
import { getCustomersList, resetCustomersList, getCustomerStats, resetUpdateCustomerStatusResponse, resetAddCustomerResponse } from '../../store/actions/customerAction.js';

const Customers = () => {

    const customerStatsResponse = useSelector((state) => state.customer?.customerStatsResponse);
    const customersListResponse = useSelector((state) => state.customer?.customersListResponse);
    const deleteOrganizationResponse = useSelector((state)=> state.organization?.deleteOrganizationResponse);
    const updateCustomerStatusResponse = useSelector((state) => state.customer?.updateCustomerStatusResponse);

    const addCustomerResponse = useSelector((state) => state.customer?.addCustomerResponse);

    const dispatch = useDispatch();

    const { t } = useTranslation();

    const [viewType, setViewType] = useState('tile');
    const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [updatedSearchValue, setUpdatedSearchValue] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isStatsLoading, setIsStatsLoading] = useState(false);
    const [customersList, setCustomersList] = useState(null);

    const closeAddCutomerModal = () => {
        setShowAddCustomerModal(false)
    }
    
    const searchOrganization = (event) => {
        setSearchValue(event.target.value);
        requestSearch(event.target.value)
        setCurrentPage(1);
    }   

    const requestSearch = useMemo(() => debounce((searchTerm) => {        
        setUpdatedSearchValue(searchTerm)
    }, 500), []);

    const fetchCustomersList = useCallback(()=>{
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}`;
        const queryParams = updatedSearchValue ? `&query=${updatedSearchValue}` : "";
        const url = `${baseUrl}${queryParams}`;
        setIsLoading(true);
        dispatch(getCustomersList(url))
    },[updatedSearchValue, currentPage, currentPageSize, dispatch])

    const fetchCustomerStats = useCallback(()=> {
        setIsStatsLoading(true);
        dispatch(getCustomerStats());
    },[dispatch])
    

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const backToMainPage = () => {
        if(addCustomerResponse?.detail?.status === "success") {
            setIsLoading(true)
            setCurrentPage(1);
            setCurrentPageSize(10);
            fetchCustomersList();
            fetchCustomerStats();
        }
        dispatch(resetAddCustomerResponse())
        closeAddCutomerModal()
    }

    useEffect(()=>{
        fetchCustomerStats();
    },[fetchCustomerStats])
    
    useEffect(() => {
        fetchCustomersList();
    }, [currentPage, currentPageSize, fetchCustomersList]);
    
    useEffect(() => {
        if(customersListResponse!= null) {
            setIsLoading(false)
            setCustomersList(customersListResponse)
            dispatch(resetCustomersList())
        }
    }, [customersListResponse, dispatch]);
    
    useEffect(()=>{
        if(deleteOrganizationResponse != null) {
            if(deleteOrganizationResponse?.detail?.status === "success") {
                setIsLoading(true)
                fetchCustomersList();
                fetchCustomerStats();
            }
        }
    },[deleteOrganizationResponse, fetchCustomersList, fetchCustomerStats])

    useEffect(()=>{
        if(updateCustomerStatusResponse !== null) {
            if(updateCustomerStatusResponse?.detail?.status === "success") {
                fetchCustomersList();
                fetchCustomerStats();
                dispatch(resetUpdateCustomerStatusResponse());
            }
        }
    },[updateCustomerStatusResponse, fetchCustomersList, fetchCustomerStats, dispatch])

    useEffect(()=>{
        if(customerStatsResponse !== null) {
            setIsStatsLoading(false);
        }
    },[customerStatsResponse])

   
    return (
        <div className="organization-container">
            <SideNav />
            <div className="organization-page-container">
                <div className="page-header-container px-4 py-3 d-flex align-items-center justify-content-between">
                    <div className="header-left">
                        <h1>{t("customers.heading")}</h1>
                    </div>
                    <div className="header-right">
                        <button onClick={()=>{setShowAddCustomerModal(true)}}><span>&#43;</span>{t("customers.addCustomer")}</button>
                    </div>
                </div>
                <div className="page-search-header px-4 py-3  d-flex align-items-center justify-content-between">
                    <div className="left-search-container position-relative">
                        <span className="position-absolute search-icon">{searchIcon()}</span>
                        <input type='text' placeholder='Search Customer' className="search-input" value={searchValue} onChange={searchOrganization}/>
                    </div>
                    <div className="right-view-option d-flex">
                        <div className={`tile-view-image ${viewType === 'tile' ? 'active' : ''}`} onClick={()=>setViewType('tile')}>
                            {tileViewIcon()}
                        </div>
                        <div className={`list-view-image ${viewType === 'list' ? 'active' : ''}`} onClick={()=>setViewType('list')}>
                            {listViewIcon()}
                        </div>
                    </div>
                </div>
                <div className="page-main-section p-4 cutomers-page">
                    <div className="total-domain-scans d-flex mt-3 rounded">
                        {
                            isStatsLoading ?
                                <div className="total-domains-container total-customers-container rounded p-3">
                                    <SkeletonLoader type={"line"} count={2} currentPage={"customers"}/>
                                </div>
                            :
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <div className="total-domains-container total-customers-container rounded p-3">
                                    <div className='domain-icon'>
                                        <h4 className="m-0 mt-1">{formatNumber(customerStatsResponse?.customers?.total)}</h4>
                                        <div className="user-count mx-3 mt-2">
                                            <span className='active-icon d-inline-block'></span>
                                            <span className='passive-icon d-inline-block'></span>
                                            <p className='total-scans-text'>{t('customers.totalCustomers')}</p>
                                        </div>
                                    </div>
                                    <div className="p-wrapper d-flex justify-content-between gap-3">
                                        <p className='mt-2'><span className='count d-inline-block'>{formatNumber(customerStatsResponse?.customers?.active)}</span>{t('customers.activeCustomers')}</p>
                                        <p className='mt-2'><span className='count-passive'>{formatNumber(customerStatsResponse?.customers?.disable)}</span>{t('customers.disabledCustomers')}</p>
                                    </div>
                                </div>
                            </motion.div>
                        }
                        {
                            isStatsLoading ?
                                <div className="total-domains-container total-customers-subscription rounded p-3">
                                    <SkeletonLoader type={"line"} count={2} currentPage={"customers"}/>
                                </div>
                            :
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <div className="total-domains-container total-customers-subscription rounded p-3">
                                    <div className='domain-icon'>
                                        <h4 className="m-0 mt-1">{customerStatsResponse?.subscriptions?.total}</h4>
                                        <div className="user-count mx-3 mt-2">
                                            <span className='active-icon d-inline-block'></span>
                                            <span className='passive-icon d-inline-block'></span>
                                            <p className='total-scans-text'>{t('customers.totalSubscription')}</p>
                                        </div>
                                    </div>
                                    <div className="p-wrapper d-flex justify-content-between gap-3">
                                        <p className='mt-2'><span className='count d-inline-block'>{customerStatsResponse?.subscriptions?.trial}</span>{t('customers.demo')}</p>
                                        <p className='mt-2'><span className='count-passive'>{customerStatsResponse?.subscriptions?.standard}</span>{t('customers.business')}</p>
                                    </div>
                                </div>
                            </motion.div>
                        }
                    </div>
                    <h2 className="heading">{t("customers.selectCustomer")}</h2>
                    {viewType === 'tile' && <CustomersTileView customersList={customersList} isLoading={isLoading}/>}
                    {viewType === 'list' && <CutomersListView customersList={customersList} isLoading={isLoading}/>}
                    {customersList != null && !isLoading && customersList?.results.length > 0 && <Pagination
                        className="pagination-bar"
                        currentPage={currentPage}
                        pageSize={currentPageSize}
                        totalCount={customersList?.meta?.total_results}
                        onPageChange={setCurrentPageandRecordSize}
                    />}
                    {
                        !isLoading && customersList?.meta?.total_results === 0 && 
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <NoDataFound />
                        </motion.div>
                    }                    
                </div>
            </div>
            <SideModal showSidePanel={showAddCustomerModal} hideSidePanel={backToMainPage}>
                {showAddCustomerModal && <AddCustomerModal backToMainPage={backToMainPage} />}
            </SideModal>
        </div>
    )
}

export default Customers;